
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.875 8.842h9.375c1.125 0 2.125.884 2.125 2.147v9.474c0 1.137-.875 2.147-2.125 2.147h-9.375a2.118 2.118 0 01-2.125-2.147V10.99c.125-1.136 1-2.147 2.125-2.147z","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M4.625 15.158h-1A2.118 2.118 0 011.5 13.01V3.537c0-1.137.875-2.147 2.125-2.147H13c1.125 0 2.125.884 2.125 2.147v1.01","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    